export const INLINE_TOOLBAR_SHOW = 'textEditor/INLINE_TOOLBAR_SHOW';

export const inlineToolbarShown = payload => ({
  type: INLINE_TOOLBAR_SHOW,
  payload,
});



// WEBPACK FOOTER //
// ./app/actions/inline-toolbar-shown.js